import type { GroupCost } from '@entities/schedules/service/types';
import { memo, useMemo } from 'react';
import { GroupsRoutesPaths } from '@pages/clients/index';
import {
  useFieldArrayCreatorConnectedToForm,
  type UseFieldArrayCreatorConnectedToFormT,
} from '@shared/hooks/useFieldArrayCreatorConnectedToForm';
import { CostAndGroupNameWithButton } from '@shared/ui/costsForGroups/ui/CostAndGroupNameWithButton/ui';
import { FormFieldWithLabelAndPlusBtn } from '@shared/ui/forms/FieldWithLabel/index';

type PT = Omit<
  UseFieldArrayCreatorConnectedToFormT,
  'nameOfEntity' | 'redirectRoute' | 'selectedInitIds' | 'initData'
> & {
  defaultCostValue?: number;
  minCostValue?: number;
  initData?: GroupCost[];
  paymentMethodFieldName?: string;
};

export const FormCostForGroupsEditor = memo(
  ({ defaultCostValue, minCostValue, initData, paymentMethodFieldName, ...props }: PT) => {
    const initFieldArrayData = useMemo(
      () =>
        initData?.map((el) => {
          const costElement: any = { cost: el.cost / 100, entityId: el.group.id };
          if (el.payment_method) {
            costElement.payment_method = el.payment_method;
          }
          return costElement;
        }),
      [initData]
    );

    const {
      register,
      removeFormFiled,
      doRemoveId,
      formFields,
      onAddEntityIds,
      setValue,
      nameOfFieldArray,
      selectedIds,
    } = useFieldArrayCreatorConnectedToForm({
      nameOfEntity: 'groups',
      redirectRoute: GroupsRoutesPaths.index,
      initData: initFieldArrayData || [],
      // initialValuesObject: { cost: defaultCostValue || 0 },
      ...props,
    });

    // console.log('formFields', formFields);
    // console.log('selectedIds', selectedIds);

    return (
      <FormFieldWithLabelAndPlusBtn
        label="Стоимость для групп"
        onBtnClick={onAddEntityIds}
        withBigButton={formFields.length === 0}
      >
        {formFields.map((field, index) => {
          const groupElement = initData?.find((el) => el?.group?.id === field.entityId);

          register(`${nameOfFieldArray}.${index}.entityId`, { value: field.entityId });
          // console.log('groupElement:', groupElement);

          const costRegister = register(`${nameOfFieldArray}.${index}.cost`, {
            value: (groupElement && groupElement?.cost / 100) || defaultCostValue,
          });

          return (
            <CostAndGroupNameWithButton
              index={index}
              nameOfFieldArray={nameOfFieldArray}
              key={field.id}
              costRegister={costRegister}
              group={groupElement?.group}
              groupId={field.entityId}
              onBtnClick={() => {
                removeFormFiled(index);
                doRemoveId(field.entityId);
              }}
              defaultValue={defaultCostValue}
              min={minCostValue}
              // required
              validationMessage={'Укажите стоимость для группы'}
              withPaymentMethod={
                paymentMethodFieldName
                  ? {
                      onChange: (v) =>
                        setValue(`${nameOfFieldArray}.${index}.${paymentMethodFieldName}`, v),
                    }
                  : undefined
              }
            />
          );
        })}
      </FormFieldWithLabelAndPlusBtn>
    );
  }
);
